import React from "react";
import { api } from "../../../lib/gameApi";
import { ChatRoom } from "./ChatRoom";

export default function VillainChat({ gameId, me }) {
  return (
    <ChatRoom
      gameId={gameId}
      me={me}
      subcollection="villainChat"
      postMessage={api.postVillainChat}
      inputId="villain-chat-input"
      ariaLabel="Villain chat"
      placeholder="Enter a message"
    />
  );
}
